import { z } from "zod";
import YAML from "yaml";
import fs from "fs/promises";

/**
 * Zod schema for the .envfortress.secrets.enc file.
 */
export const SecretEntrySchema = z.union([
  z.string(),
  z.object({
    meta: z.record(z.string(), z.any()).optional(),
    value: z.string(),
  }),
]);

export const SecretsFileSchema = z.object({
  version: z.number(),
  teamVersion: z.number().optional(),
  revoked: z.array(z.string()).optional(),
  secrets: z.record(z.string(), SecretEntrySchema),
  signature: z
    .object({
      signer: z.string(),
      method: z.string(),
      verified: z.boolean(),
    })
    .optional(),
});

export type SecretEntry = z.infer<typeof SecretEntrySchema>;
export type SecretsFile = z.infer<typeof SecretsFileSchema>;

/**
 * Reads and validates a .envfortress.secrets.enc YAML file.
 */
export async function readSecretsFile(path: string): Promise<SecretsFile> {
  const content = await fs.readFile(path, "utf-8");
  const parsed = YAML.parse(content);
  return SecretsFileSchema.parse(parsed);
}

/**
 * Serializes and writes a .envfortress.secrets.enc YAML file.
 */
export async function writeSecretsFile(
  path: string,
  data: SecretsFile
): Promise<void> {
  const yaml = YAML.stringify(data);
  await fs.writeFile(path, yaml, "utf-8");
}
